import * as React from 'react';
import { differenceInCalendarDays, isAfter, isBefore } from 'date-fns';
import { isDayPickerRange } from "../../types";
import { SelectRangeContext } from "./SelectRangeContext";
import { addToRange } from "./utils/addToRange";
/** Provides the values for the [[SelectRangeProvider]]. */

export function SelectRangeProvider(_a) {
  var initialProps = _a.initialProps,
      children = _a.children;
  var initialSelected;
  var isRangeMode = false;
  var min, max;

  if (isDayPickerRange(initialProps)) {
    isRangeMode = true;
    initialSelected = initialProps.defaultSelected;
    min = initialProps.min;
    max = initialProps.max;
  }

  var _b = React.useState(initialSelected),
      selected = _b[0],
      setSelected = _b[1];

  var handleDayClick = function handleDayClick(day, modifiers, e) {
    var _a, _b;

    (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, modifiers, e);

    if (!isDayPickerRange(initialProps)) {
      return;
    }

    var newValue = addToRange(day, selected);

    if ((min || max) && selected && (newValue === null || newValue === void 0 ? void 0 : newValue.to) && newValue.from && newValue.from !== newValue.to) {
      var diff = Math.abs(differenceInCalendarDays(newValue === null || newValue === void 0 ? void 0 : newValue.to, newValue === null || newValue === void 0 ? void 0 : newValue.from));

      if (min && diff < min) {
        return;
      }

      if (max && diff >= max) {
        return;
      }
    }

    setSelected(newValue);
    (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, newValue, day, modifiers, e);
  };

  var modifiers = {
    selected: [],
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };

  if (selected) {
    modifiers.selected = [selected];

    if (selected.from) {
      modifiers.range_start = [selected.from];

      if (selected.to) {
        modifiers.range_middle = [{
          after: selected.from,
          before: selected.to
        }];

        if (max || min) {
          modifiers.disabled = [function (date) {
            if (max && selected.to && selected.from && isBefore(date, selected.from)) {
              var diff = differenceInCalendarDays(selected.to, date);

              if (diff >= max) {
                return true;
              }
            }

            if (max && selected.to && selected.from && isAfter(date, selected.to)) {
              var diff = differenceInCalendarDays(date, selected.from);

              if (diff >= max) {
                return true;
              }
            }

            if (min && selected.from && isBefore(date, selected.from)) {
              var diff = differenceInCalendarDays(selected.from, date);

              if (diff < min) {
                return true;
              }
            }

            if (min && selected.to && selected.from && isAfter(date, selected.to)) {
              var diff = differenceInCalendarDays(date, selected.from);

              if (diff < min) {
                return true;
              }
            }

            return false;
          }];
        }

        modifiers.range_end = [selected.to];
      } else {
        modifiers.range_end = [selected.from];
      }
    }
  }

  return /*#__PURE__*/React.createElement(SelectRangeContext.Provider, {
    value: {
      selected: selected,
      handleDayClick: handleDayClick,
      modifiers: modifiers,
      isRangeMode: isRangeMode
    }
  }, children);
}